var map = {
	"./bet575/images/close-filter.svg": 1161,
	"./bet575/images/logo/logoMb.svg": 1162,
	"./bet777/icons/horse.svg": 1163,
	"./bet777/icons/soccer-1.svg": 1164,
	"./bet777/images/close-filter.svg": 1165,
	"./bet777/images/logo.svg": 1166,
	"./bet777/images/logoMb.svg": 1167,
	"./betblast/images/close-filter.svg": 1168,
	"./betgalaxy/icons/qamAccountOverview.svg": 1169,
	"./betgalaxy/icons/qamLogOut.svg": 1170,
	"./betgalaxy/icons/qamMyBets.svg": 1171,
	"./betgalaxy/icons/qamSupport.svg": 1172,
	"./betgalaxy/images/betslip/betSlipIcon.svg": 1173,
	"./betgalaxy/images/betslip/closeButton.svg": 1174,
	"./betgalaxy/images/betslip/estReturnIcon.svg": 1175,
	"./betgalaxy/images/emptyBetslip.svg": 1176,
	"./betgalaxy/images/logo.svg": 1177,
	"./betgalaxy/images/logoMobile.svg": 1178,
	"./betgalaxy/images/switch/blue-ufo.svg": 1179,
	"./betgalaxy/images/switch/green-ufo.svg": 1180,
	"./betgalaxy/images/switch/moon.svg": 1181,
	"./betprofessor/icons/ContactUs.svg": 1182,
	"./betprofessor/icons/MultiBet.svg": 1183,
	"./betprofessor/icons/MyAccount.svg": 1184,
	"./betprofessor/icons/Promo.svg": 1185,
	"./betprofessor/images/logo.svg": 1186,
	"./betprofessor/images/logo/logo.svg": 1187,
	"./betprofessor/images/racing/fav.svg": 1188,
	"./betroyale/icons/ContactUs.svg": 1189,
	"./betroyale/icons/Deposit.svg": 1190,
	"./betroyale/icons/Greyhounds.svg": 1191,
	"./betroyale/icons/Home.svg": 1192,
	"./betroyale/icons/MyAccount.svg": 1193,
	"./betroyale/icons/Promo.svg": 1194,
	"./betroyale/icons/Promotions.svg": 1195,
	"./betroyale/icons/ScrewWrench.svg": 1196,
	"./betroyale/icons/Sports.svg": 1197,
	"./betroyale/icons/horse_racing.svg": 1198,
	"./betroyale/images/backgrounds/battlements.svg": 1199,
	"./betroyale/images/header/cards.svg": 1200,
	"./betroyale/images/logo.svg": 1201,
	"./betroyale/images/logos/logo-desktop.svg": 1202,
	"./betroyale/images/logos/logo-mobile.svg": 1203,
	"./betroyale/images/nav/crown.svg": 1204,
	"./betstride/images/backgrounds/BetStrideBorder.svg": 1205,
	"./betstride/images/close-filter.svg": 1206,
	"./betstride/images/gradient-border.svg": 1207,
	"./betstride/images/switch/gradient-border.svg": 1208,
	"./buffalobet/images/backgrounds/onboardingLogo.svg": 1209,
	"./buffalobet/images/close-filter.svg": 1210,
	"./buffalobet/images/error/logoErr.svg": 1211,
	"./buffalobet/images/footer/logoFooter.svg": 1212,
	"./buffalobet/images/logo.svg": 1213,
	"./buffalobet/images/logoMb.svg": 1214,
	"./chromabet/icons/MultiBet.svg": 1215,
	"./core/badges/aqua-runner.svg": 908,
	"./core/badges/away-early.svg": 909,
	"./core/badges/best-rated.svg": 910,
	"./core/badges/box-specialist.svg": 911,
	"./core/badges/champion-dog.svg": 912,
	"./core/badges/champion-horse.svg": 913,
	"./core/badges/consistent-performer.svg": 914,
	"./core/badges/distance-expert.svg": 915,
	"./core/badges/donkey.svg": 916,
	"./core/badges/dynamic-duo.svg": 917,
	"./core/badges/early-away.svg": 918,
	"./core/badges/favourite-distance.svg": 919,
	"./core/badges/featherweight-champion.svg": 920,
	"./core/badges/first-timer.svg": 921,
	"./core/badges/hercules.svg": 922,
	"./core/badges/last-start-winner.svg": 923,
	"./core/badges/likes-the-ground.svg": 924,
	"./core/badges/mile-high.svg": 925,
	"./core/badges/picket-fence.svg": 926,
	"./core/badges/place-performer.svg": 927,
	"./core/badges/ready-to-go.svg": 928,
	"./core/badges/returning-from-rest.svg": 929,
	"./core/badges/roughie.svg": 930,
	"./core/badges/striking-distance.svg": 931,
	"./core/badges/strong-finisher.svg": 932,
	"./core/badges/strong-home-section.svg": 933,
	"./core/badges/top-pedigree.svg": 934,
	"./core/badges/track-specialist.svg": 935,
	"./core/badges/well-rested.svg": 936,
	"./core/icons/BetRefund-Notification.svg": 533,
	"./core/icons/BetWon-Notification.svg": 534,
	"./core/icons/BonusBet-Notification.svg": 535,
	"./core/icons/ContactUs.svg": 536,
	"./core/icons/Deposit.svg": 537,
	"./core/icons/GaugeHighSolid.svg": 538,
	"./core/icons/LiveChat.svg": 539,
	"./core/icons/Logo2.svg": 540,
	"./core/icons/QRacingQueensland.svg": 541,
	"./core/icons/RWWA.svg": 542,
	"./core/icons/RacingNSW.svg": 543,
	"./core/icons/ResponsibleGambling.svg": 544,
	"./core/icons/TasRacing.svg": 545,
	"./core/icons/ThoroughbredPark.svg": 546,
	"./core/icons/accountUnverified.svg": 547,
	"./core/icons/accountVerified.svg": 548,
	"./core/icons/afl_football.svg": 549,
	"./core/icons/all_sports.svg": 550,
	"./core/icons/american_football.svg": 551,
	"./core/icons/angleRightSolid.svg": 552,
	"./core/icons/arrowDown.svg": 553,
	"./core/icons/arrowUp.svg": 554,
	"./core/icons/australian_rules.svg": 555,
	"./core/icons/badminton.svg": 556,
	"./core/icons/baseball.svg": 557,
	"./core/icons/basketball.svg": 558,
	"./core/icons/beach_volleyball.svg": 559,
	"./core/icons/bonusBetIcon.svg": 560,
	"./core/icons/box_challenge.svg": 561,
	"./core/icons/boxing.svg": 562,
	"./core/icons/calendar.svg": 563,
	"./core/icons/cashout.svg": 564,
	"./core/icons/contact_us.svg": 565,
	"./core/icons/cricket.svg": 566,
	"./core/icons/cycling.svg": 567,
	"./core/icons/darts.svg": 568,
	"./core/icons/default.svg": 569,
	"./core/icons/depositDirect.svg": 570,
	"./core/icons/dropdownArrow.svg": 571,
	"./core/icons/ellipsis.svg": 572,
	"./core/icons/emptyBetSlip.svg": 573,
	"./core/icons/emptyMultiIcon.svg": 574,
	"./core/icons/eye.svg": 575,
	"./core/icons/eyeSlash.svg": 576,
	"./core/icons/facebook.svg": 577,
	"./core/icons/field_hockey.svg": 578,
	"./core/icons/fighting.svg": 579,
	"./core/icons/football.svg": 580,
	"./core/icons/golf.svg": 581,
	"./core/icons/greyhounds.svg": 582,
	"./core/icons/harness_racing.svg": 583,
	"./core/icons/horseRacingIcon.svg": 584,
	"./core/icons/horse_racing.svg": 585,
	"./core/icons/ice_hockey.svg": 586,
	"./core/icons/iconAlert.svg": 587,
	"./core/icons/iconAlertYellow.svg": 588,
	"./core/icons/iconCheckMarkCircle.svg": 589,
	"./core/icons/jockey_challenge.svg": 590,
	"./core/icons/key.svg": 591,
	"./core/icons/keypadDelete.svg": 592,
	"./core/icons/lawn_bowls.svg": 593,
	"./core/icons/leftArrowWall.svg": 594,
	"./core/icons/lifeRaft.svg": 595,
	"./core/icons/loadingspinner.svg": 596,
	"./core/icons/log_out.svg": 597,
	"./core/icons/logout.svg": 598,
	"./core/icons/mastercard.svg": 599,
	"./core/icons/mb-logo.svg": 600,
	"./core/icons/megaphone.svg": 601,
	"./core/icons/mma.svg": 602,
	"./core/icons/money-back.svg": 603,
	"./core/icons/motor_racing.svg": 604,
	"./core/icons/motor_sport.svg": 605,
	"./core/icons/multi_betslip.svg": 606,
	"./core/icons/navBars.svg": 607,
	"./core/icons/netball.svg": 608,
	"./core/icons/passwordPeek.svg": 609,
	"./core/icons/paymentTick.svg": 610,
	"./core/icons/paymentX.svg": 611,
	"./core/icons/person.svg": 612,
	"./core/icons/personAdd.svg": 613,
	"./core/icons/politics.svg": 614,
	"./core/icons/presentforMark.svg": 615,
	"./core/icons/promPref.svg": 616,
	"./core/icons/racing.svg": 617,
	"./core/icons/racing_extras.svg": 618,
	"./core/icons/rightArrow.svg": 619,
	"./core/icons/rugby_league.svg": 620,
	"./core/icons/rugby_union.svg": 621,
	"./core/icons/sideNavClose.svg": 622,
	"./core/icons/snooker.svg": 623,
	"./core/icons/soccer.svg": 624,
	"./core/icons/specials.svg": 625,
	"./core/icons/spinArrow.svg": 626,
	"./core/icons/sport_futures.svg": 627,
	"./core/icons/sports_az.svg": 628,
	"./core/icons/sports_exotics.svg": 629,
	"./core/icons/sports_futures.svg": 630,
	"./core/icons/squareStack.svg": 631,
	"./core/icons/square_question.svg": 632,
	"./core/icons/square_right.svg": 633,
	"./core/icons/surfing.svg": 634,
	"./core/icons/table_tennis.svg": 635,
	"./core/icons/tennis.svg": 636,
	"./core/icons/thumbsUp.svg": 637,
	"./core/icons/todays_offers.svg": 638,
	"./core/icons/tooltip-icon.svg": 639,
	"./core/icons/treasure_chest.svg": 640,
	"./core/icons/triangleDown.svg": 641,
	"./core/icons/twitter.svg": 642,
	"./core/icons/visa.svg": 643,
	"./core/icons/volleyball.svg": 644,
	"./core/images/accountUnverified.svg": 1216,
	"./core/images/accountVerified.svg": 1217,
	"./core/images/androidButton.svg": 1218,
	"./core/images/arrowDown.svg": 1219,
	"./core/images/arrowUp.svg": 1220,
	"./core/images/banner/desktop.svg": 1221,
	"./core/images/banner/mobile.svg": 1222,
	"./core/images/calendar.svg": 1223,
	"./core/images/defaultSilk.svg": 1224,
	"./core/images/dropdownArrow.svg": 1225,
	"./core/images/ellipsis.svg": 1226,
	"./core/images/emptyBetSlip.svg": 1227,
	"./core/images/facebook.svg": 1228,
	"./core/images/horseRacingIcon.svg": 1229,
	"./core/images/iconAlert.svg": 1230,
	"./core/images/iconAlertYellow.svg": 1231,
	"./core/images/iconCheckMarkCircle.svg": 1232,
	"./core/images/iosButton.svg": 1233,
	"./core/images/key.svg": 1234,
	"./core/images/keypadDelete.svg": 1235,
	"./core/images/leftArrowWall.svg": 1236,
	"./core/images/lifeRaft.svg": 1237,
	"./core/images/logo.svg": 1238,
	"./core/images/navBars.svg": 1239,
	"./core/images/passwordPeek.svg": 1240,
	"./core/images/person.svg": 1241,
	"./core/images/personAdd.svg": 1242,
	"./core/images/rightArrow.svg": 1243,
	"./core/images/sideNavClose.svg": 1244,
	"./core/images/spinArrow.svg": 1245,
	"./core/images/sports/afl.svg": 1246,
	"./core/images/sports/afl_football.svg": 1247,
	"./core/images/sports/american_football.svg": 1248,
	"./core/images/sports/badminton.svg": 1249,
	"./core/images/sports/baseball.svg": 1250,
	"./core/images/sports/basketball.svg": 1251,
	"./core/images/sports/beach_volleyball.svg": 1252,
	"./core/images/sports/box_challenge.svg": 1253,
	"./core/images/sports/boxing.svg": 1254,
	"./core/images/sports/cricket.svg": 1255,
	"./core/images/sports/cycling.svg": 1256,
	"./core/images/sports/darts.svg": 1257,
	"./core/images/sports/default.svg": 1258,
	"./core/images/sports/field_hockey.svg": 1259,
	"./core/images/sports/golf.svg": 1260,
	"./core/images/sports/greyhounds.svg": 1261,
	"./core/images/sports/harness_racing.svg": 1262,
	"./core/images/sports/horse_racing.svg": 1263,
	"./core/images/sports/ice_hockey.svg": 1264,
	"./core/images/sports/jockey_challenge.svg": 1265,
	"./core/images/sports/lawn_bowls.svg": 1266,
	"./core/images/sports/motor_sport.svg": 1267,
	"./core/images/sports/politics.svg": 1268,
	"./core/images/sports/racing.svg": 1269,
	"./core/images/sports/racing_extras.svg": 1270,
	"./core/images/sports/rugby_league.svg": 1271,
	"./core/images/sports/rugby_union.svg": 1272,
	"./core/images/sports/snooker.svg": 1273,
	"./core/images/sports/soccer.svg": 1274,
	"./core/images/sports/sports_exotics.svg": 1275,
	"./core/images/sports/square_question.svg": 1276,
	"./core/images/sports/surfing.svg": 1277,
	"./core/images/sports/tennis.svg": 1278,
	"./core/images/sports/todays_offers.svg": 1279,
	"./core/images/squareStack.svg": 1280,
	"./core/images/triangleDown.svg": 1281,
	"./core/images/twitter.svg": 1282,
	"./fiestabet/icons/ContactUs.svg": 1283,
	"./fiestabet/icons/Deposit.svg": 1284,
	"./fiestabet/icons/Home.svg": 1285,
	"./fiestabet/icons/LiveChat.svg": 1286,
	"./fiestabet/icons/MyAccount.svg": 1287,
	"./fiestabet/icons/Promo.svg": 1288,
	"./fiestabet/icons/Sports.svg": 1289,
	"./fiestabet/icons/horsey.svg": 1290,
	"./fiestabet/images/backgrounds/mobileBackground.svg": 1291,
	"./fiestabet/images/loader.svg": 1292,
	"./fiestabet/images/logo-mobile.svg": 1293,
	"./fiestabet/images/logo.svg": 1294,
	"./fiestabet/images/mobile_logo.svg": 1295,
	"./fiestabet/images/switch/old-board.svg": 1296,
	"./fiestabet/images/switch/skull-coin.svg": 1297,
	"./forsport/images/homeFeaturedSport/limitsv.svg": 1298,
	"./forsport/images/logo-brand.svg": 1299,
	"./forsport/images/volleyball.svg": 1300,
	"./gigabet/icons/ContactUsGG.svg": 1301,
	"./gigabet/icons/DepositGG.svg": 1302,
	"./gigabet/icons/MyAccountGG.svg": 1303,
	"./gigabet/icons/ResponsibleGambling.svg": 1304,
	"./gigabet/icons/SportsGG.svg": 1305,
	"./gigabet/images/close-filter.svg": 1306,
	"./gigabet/images/racing/mysteryBetLogo.svg": 1307,
	"./gigabet/images/toggle/toggleInner.svg": 1308,
	"./gigabet/images/toggle/toggleOuter.svg": 1309,
	"./gigabet/images/toggle/toggleTick.svg": 1310,
	"./goldenbet888/icons/ContactUs888.svg": 1311,
	"./goldenbet888/icons/Deposit888.svg": 1312,
	"./goldenbet888/icons/MyAccount888.svg": 1313,
	"./goldenbet888/icons/ResponsibleGambling888.svg": 1314,
	"./goldenbet888/icons/Sports888.svg": 1315,
	"./goldenbet888/images/close-filter.svg": 1316,
	"./goldenbet888/images/sideNav/squigglyBorder.svg": 1317,
	"./goldenrush/icons/greyhounds.svg": 1318,
	"./goldenrush/icons/harness_racing.svg": 1319,
	"./goldenrush/icons/horse_racing.svg": 1320,
	"./goldenrush/icons/loadingspinner.svg": 1321,
	"./goldenrush/images/logo.svg": 1322,
	"./goldenrush/images/logoFooter.svg": 1323,
	"./hyperbet/icons/ContactUsHB.svg": 1324,
	"./hyperbet/icons/DepositHB.svg": 1325,
	"./hyperbet/icons/HomeHB.svg": 1326,
	"./hyperbet/icons/MyAccountHB.svg": 1327,
	"./hyperbet/icons/PromoHB.svg": 1328,
	"./hyperbet/icons/ResponsibleGambling.svg": 1329,
	"./hyperbet/icons/SportsHB.svg": 1330,
	"./hyperbet/images/close-filter.svg": 1331,
	"./juicybet/icons/all_sports.svg": 1332,
	"./juicybet/icons/boxing.svg": 1333,
	"./juicybet/icons/contactUs.svg": 1334,
	"./juicybet/icons/cricket.svg": 1335,
	"./juicybet/icons/deposit.svg": 1336,
	"./juicybet/icons/greyhounds.svg": 1337,
	"./juicybet/icons/harness_racing.svg": 1338,
	"./juicybet/icons/home.svg": 1339,
	"./juicybet/icons/horse_racing.svg": 1340,
	"./juicybet/icons/my_account.svg": 1341,
	"./juicybet/icons/promotions.svg": 1342,
	"./junglebet/images/logos/logoDesktop.svg": 1343,
	"./junglebet/images/switch/vineLeft.svg": 1344,
	"./junglebet/images/switch/vineRight.svg": 1345,
	"./magnumbet/images/close-filter.svg": 1346,
	"./puntcity/icons/ContactUs.svg": 1347,
	"./puntcity/icons/Deposit.svg": 1348,
	"./puntcity/icons/Home.svg": 1349,
	"./puntcity/icons/MyAccount.svg": 1350,
	"./puntcity/icons/Promo.svg": 1351,
	"./puntcity/icons/Sports.svg": 1352,
	"./puntcity/images/cityClosed.svg": 1353,
	"./puntcity/images/homeFeaturedSport/limitsv.svg": 1354,
	"./puntcity/images/logo.svg": 1355,
	"./puntgenie/icons/ContactUs.svg": 1356,
	"./puntgenie/icons/Deposit.svg": 1357,
	"./puntgenie/icons/Home.svg": 1358,
	"./puntgenie/icons/MyAccount.svg": 1359,
	"./puntgenie/icons/Promo.svg": 1360,
	"./puntgenie/icons/ScrewWrench.svg": 1361,
	"./puntgenie/icons/Sports.svg": 1362,
	"./puntgenie/images/logo.svg": 1363,
	"./puntgenie/images/logoMobile.svg": 1364,
	"./puntgenie/images/switch/ruby.svg": 1365,
	"./pyramidbet/images/border/borderDark2Light.svg": 1366,
	"./pyramidbet/images/border/borderLight2Dark.svg": 1367,
	"./pyramidbet/images/close-filter.svg": 1368,
	"./questbet/icons/ContactUs.svg": 1369,
	"./questbet/icons/Home.svg": 1370,
	"./questbet/icons/MyAccount.svg": 1371,
	"./questbet/icons/Promo.svg": 1372,
	"./questbet/icons/ScrewWrench.svg": 1373,
	"./questbet/images/backgrounds/get-verified.svg": 1374,
	"./questbet/images/header/qblogo-white.svg": 1375,
	"./questbet/images/logo.svg": 1376,
	"./questbet/images/mobile_logo.svg": 1377,
	"./questbet/images/nav/coins.svg": 1378,
	"./questbet/images/nav/ninjauser.svg": 1379,
	"./questbet/images/toggle/toggle.svg": 1380,
	"./slambet/icons/ContactUs.svg": 1381,
	"./slambet/icons/DepositSlam.svg": 1382,
	"./slambet/icons/MyAccount.svg": 1383,
	"./slambet/icons/ResponsibleGambling.svg": 1384,
	"./slambet/icons/Sports.svg": 1385,
	"./slambet/images/backgrounds/gradientBorderSmall.svg": 1386,
	"./slambet/images/backgrounds/iconBg.svg": 1387,
	"./slambet/images/backgrounds/slamBorder.svg": 1388,
	"./slambet/images/close-filter.svg": 1389,
	"./sterlingparker/icons/ContactUs.svg": 1390,
	"./sterlingparker/icons/Deposit.svg": 1391,
	"./sterlingparker/icons/Home.svg": 1392,
	"./sterlingparker/icons/LiveChat.svg": 1393,
	"./sterlingparker/icons/MyAccount.svg": 1394,
	"./sterlingparker/icons/PlaceBetsIconSP.svg": 1395,
	"./sterlingparker/icons/Promo.svg": 1396,
	"./sterlingparker/icons/ResponsibleGambling.svg": 1397,
	"./sterlingparker/icons/Sports.svg": 1398,
	"./sterlingparker/images/logo-location-not-allowed.svg": 1399,
	"./sterlingparker/images/logo.svg": 1400,
	"./sterlingparker/images/logoDesktop.svg": 1401,
	"./sterlingparker/images/logoFooter.svg": 1402,
	"./sterlingparker/images/logoMobile.svg": 1403,
	"./sugarcastle/icons/Badminton.svg": 1404,
	"./sugarcastle/icons/Deposit.svg": 1405,
	"./sugarcastle/icons/Diamond.svg": 1406,
	"./sugarcastle/icons/Home.svg": 1407,
	"./sugarcastle/icons/Margarita.svg": 1408,
	"./sugarcastle/icons/Parchment.svg": 1409,
	"./sugarcastle/icons/ScrewWrench.svg": 1410,
	"./sugarcastle/images/sidenav/logoSidenav.svg": 1411,
	"./templebet/icons/ContactUs.svg": 1412,
	"./templebet/icons/Deposit.svg": 1413,
	"./templebet/icons/MyAccount.svg": 1414,
	"./templebet/icons/ResponsibleGambling.svg": 1415,
	"./templebet/icons/Sports.svg": 1416,
	"./templebet/icons/close.svg": 1417,
	"./templebet/images/backgrounds/background.svg": 1418,
	"./templebet/images/close-filter.svg": 1419,
	"./templebet/images/onboarding/onboardingLogoMb.svg": 1420,
	"./templebet/images/racing/MYSTERYBET.svg": 1421,
	"./titanbet/images/close-filter.svg": 1422,
	"./vikingbet/icons/Account.svg": 1423,
	"./vikingbet/icons/Axe.svg": 1424,
	"./vikingbet/icons/Contact.svg": 1425,
	"./vikingbet/icons/Deposit.svg": 1426,
	"./vikingbet/icons/Home.svg": 1427,
	"./vikingbet/icons/Promotion.svg": 1428,
	"./vikingbet/icons/loadingspinner.svg": 1429,
	"./vikingbet/images/backgrounds/empty.svg": 1430,
	"./vikingbet/images/backgrounds/menu-arrow-left.svg": 1431,
	"./vikingbet/images/backgrounds/menu-arrow-right.svg": 1432,
	"./vikingbet/images/logo.svg": 1433,
	"./volcanobet/icons/Betslip.svg": 1434,
	"./volcanobet/icons/ContactUs.svg": 1435,
	"./volcanobet/icons/Deposit.svg": 1436,
	"./volcanobet/icons/Home.svg": 1437,
	"./volcanobet/icons/LiveChat.svg": 1438,
	"./volcanobet/icons/MultiIconVolcanobet.svg": 1439,
	"./volcanobet/icons/MyAccount.svg": 1440,
	"./volcanobet/icons/Promo.svg": 1441,
	"./volcanobet/icons/ResponsibleGambling.svg": 1442,
	"./volcanobet/icons/Sports.svg": 1443,
	"./volcanobet/images/backgrounds/hero-homepage-bg.svg": 1444,
	"./volcanobet/images/backgrounds/races-header-bg.svg": 1445,
	"./volcanobet/images/backgrounds/races-header-w-sky-bg.svg": 1446,
	"./volcanobet/images/betslip/empty-betslip.svg": 1447,
	"./volcanobet/images/betslip/pattern-top.svg": 1448,
	"./volcanobet/images/loader.svg": 1449,
	"./volcanobet/images/logo.svg": 1450,
	"./volcanobet/images/mobile_logo.svg": 1451,
	"./volcanobet/images/nav/man.svg": 1452,
	"./volcanobet/images/sidenav/mobile/caveman.svg": 1453,
	"./volcanobet/images/sidenav/mobile/ground.svg": 1454,
	"./volcanobet/images/sidenav/mobile/tiger.svg": 1455,
	"./wellbet/images/backgrounds/thumbsUp.svg": 1456,
	"./wellbet/images/backgrounds/welcome.svg": 1457,
	"./wellbet/images/emptyBetslip.svg": 1458,
	"./wellbet/images/emptyBetslipLogo.svg": 1459,
	"./wellbet/images/footer/wblogo.svg": 1460,
	"./wellbet/images/footerLogo.svg": 1461,
	"./wellbet/images/header/wblogo.svg": 1462,
	"./wellbet/images/header/woman.svg": 1463,
	"./wellbet/images/homeFeaturedRacing/featured.svg": 1464,
	"./wellbet/images/homeFeaturedRacing/horses.svg": 1465,
	"./wellbet/images/homeFeaturedRacing/mask.svg": 1466,
	"./wellbet/images/homeFeaturedRacing/ntj.svg": 1467,
	"./wellbet/images/homeFeaturedSport/boats.svg": 1468,
	"./wellbet/images/logo.svg": 1469,
	"./wellbet/images/onboardingLogo.svg": 1470,
	"./wellbet/images/toggle/volleyball.svg": 1471,
	"./wellbet/images/waterbg.svg": 1472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2431;